moment.locale('nb');
moment.tz.setDefault('Europe/Oslo');
moment.updateLocale('en', {
  week: {
    dow: 1, // Monday is the start of the week
  },
  months:
    'Januar_Februar_Mars_April_Mai_Juni_Juli_August_September_Oktober_November_Desember'.split(
      '_'
    ),
  monthsShort: 'Jan_Feb_Mars_Apr_Mai_Juni_Juli_Aug_Sep_Okt_Nov_Des'.split('_'),
  monthsParseExact: true,
  weekdays: 'Søndag_Mandag_Tirsdag_Onsdag_Torsdag_Fredag_Lørdag'.split('_'),
  weekdaysShort: 'Søn_Man_Tir_Ons_Tor_Fre_Lør'.split('_'),
  weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
});
Highcharts.setOptions({
  lang: {
    weekdays: [
      'Søndag',
      'Mandag',
      'Tirsdag',
      'Onsdag',
      'Torsdag',
      'Fredag',
      'Lørdag',
    ],
    shortWeekdays: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
    months: [
      'Januar',
      'Februar',
      'Mars',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Desember',
    ],
    shortMonths: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Des',
    ],
  },
});

// Initialize tooltips globally
$(function () {
  $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });

  if (
    !window.globalSocket ||
    window.globalSocket.readyState === WebSocket.CLOSED
  ) {
    connectWebSocket();
  }
});

/**
 *
 * @param string message
 * @param string type
 * @param string title
 * @param string classes
 * @returns {string}
 */
function getAlertHtml(message, type, title = null, classes = '') {
  var titleHtml = '';

  if (title != null && title != '') {
    titleHtml = '<strong>' + title + '</strong><br><br>';
  }

  return (
    '<div class="alert alert-' +
    type +
    ' alert-dismissible ' +
    classes +
    '" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>' +
    titleHtml +
    message +
    '</div>'
  );
}

/**
 *
 * @param string message
 * @param string type
 * @param string title
 * @returns {string}
 */
function getUnCloseAlertHtml(message, type, title = null) {
  var titleHtml = '';

  if (title != null && title != '') {
    titleHtml = '<strong>' + title + '</strong><br><br>';
  }

  return (
    '<div class="alert alert-' +
    type +
    '" id="message">' +
    titleHtml +
    message +
    '</div>'
  );
}

function getOrderToPrint(printedIdsToSend = null) {
  const device_id = localStorage.getItem('deviceID');
  const storedPrintedIds = localStorage.getItem('printedIds');
  let printedIds =
    storedPrintedIds &&
    storedPrintedIds != 'null' &&
    storedPrintedIds != 'undefined'
      ? JSON.parse(storedPrintedIds)
      : printedIdsToSend;

  const formData = new FormData();

  if (printedIds) {
    printedIds.order_ids.forEach((orderId) => {
      formData.append('order_ids[]', orderId.toString());
    });

    printedIds.order_product_ids.forEach((orderProductId) => {
      formData.append('order_product_ids[]', orderProductId.toString());
    });

    printedIds.product_table_ids.forEach((productTableId) => {
      formData.append('product_table_ids[]', productTableId.toString());
    });
  }

  formData.append('device_id', device_id);

  return $.ajax({
    type: 'POST',
    url: '/api/v1/private/order_product/get_order_products_to_print',
    data: formData,
    enctype: 'multipart/form-data',
    async: true,
    cache: false,
    processData: false,
    contentType: false,
  })
    .done(function (data) {
      isPullOrderPending = true;
      passDataToWebView(event, 'print_poll_order', data);
      localStorage.removeItem('printedIds');
    })
    .fail(function (data) {
      if (
        data.responseJSON &&
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        // document.location.href = data.responseJSON.redirect_url;
      }
    });
}

function getlatestOrderToPrint() {
  const terminal_id = localStorage.getItem('verifoneSerialNumber') || '';

  $.ajax({
    type: 'POST',
    url: '/ajax/order/get_latest_order_to_print',
    data: { terminal_id },
  })
    .done(function (data) {
      document.location.href = data.redirect_url;
    })
    .fail(function (data) {
      if (data.responseJSON && data.responseJSON.error_message) {
        showToast({
          message: data.responseJSON.error_message,
          type: 'error',
          position: 'bottom-center',
        });
      }

      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}

function loadScripts(urls, done) {
  var remaining = urls.length;

  function onLoad() {
    remaining--;
    if (remaining === 0) done();
  }

  urls.forEach(function (src) {
    if ([].slice.call(document.scripts).some((s) => s.src.includes(src))) {
      onLoad();
      return;
    }

    $.getScript(src).done(onLoad);
  });
}

/**
 *
 * @param string message
 * @param string type
 * @param string title
 * @returns {string}
 */
function getAlertTable(message, type, title = null) {
  var titleHtml = '';

  if (title != null && title != '') {
    titleHtml = '<strong>' + title + '</strong><br><br>';
  }

  return (
    '<tr><td colspan="3"><div class="alert alert-' +
    type +
    ' alert-dismissible" id="message"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>' +
    titleHtml +
    message +
    '</div></td></tr>'
  );
}

/**
 *
 * @param string prependBeforeId
 * @param string message
 * @param string type
 * @param string title
 * @param string parent
 */
function prependAlert(
  prependBeforeId,
  message,
  type,
  title = null,
  parent = null
) {
  if (parent != null && parent != '' && $(parent).length > 0) {
    $('.alert', $(parent)).remove();
  }

  $(getAlertHtml(message, type, title)).prependTo($(prependBeforeId));
}

/**
 *
 * @param string prependBeforeId
 * @param string message
 * @param string type
 * @param string title
 * @param string parent
 */
function prependAlertUnClose(
  prependBeforeId,
  message,
  type,
  title = null,
  parent = null
) {
  if (parent != null && parent != '' && $(parent).length > 0) {
    $('.alert', $(parent)).remove();
  }

  $(getUnCloseAlertHtml(message, type, title)).prependTo($(prependBeforeId));
}

/**
 *
 * @param string appendAfterId
 * @param string message
 * @param string type
 * @param string title
 * @param string parent
 */
function appendAlert(
  appendAfterId,
  message,
  type,
  title = null,
  parent = null
) {
  if (parent != null && parent != '' && $(parent).length > 0) {
    $('.alert', $(parent)).remove();
  }

  $(getAlertHtml(message, type, title)).appendTo($(appendAfterId));
}

/**
 *
 * @param string insertAfterId
 * @param string message
 * @param string type
 * @param string title
 * @param string parent
 */
function inserAfterAlertTr(
  insertAfterId,
  message,
  type,
  title = null,
  parent = null
) {
  if (parent != null && parent != '' && $(parent).length > 0) {
    $('.alert', $(parent)).remove();
  }

  $(getAlertTable(message, type, title)).insertAfter($(insertAfterId));
}

/**
 *
 */
function popupAlert() {
  if ($('#globalPopupMessage').length > 0) {
    $('#globalPopupMessage').remove();
  }

  var popup =
    '<div id="globalPopupMessage" class="bg-success text-white"><i class="material-icons">check_circle_outline</i></div>';

  $(popup).appendTo('#content');

  setTimeout(function () {
    $('#globalPopupMessage').fadeOut(500, function () {
      $('#globalPopupMessage').remove();
    });
  }, 500);
}

function formatNumber(number) {
  if (Number.isInteger(number)) {
    return number.toLocaleString('no-NO');
  } else {
    return number.toLocaleString('no-NO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}

function errorPopupAlert(message, duration = 2000) {
  // Remove existing popup if present
  if ($('#globalPopupMessage').length > 0) {
    $('#globalPopupMessage').remove();
  }

  var popup = `
    <div id="globalPopupMessage" class="alert bg-danger alert-dismissible fade show d-flex flex-column align-items-center justify-content-center text-center text-white position-fixed"
         role="alert"
         style="min-width: 320px; max-width: 90vw; max-height: 80vh; height: min-content; box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); border-radius: 12px; padding: 30px 25px;">
      <div class="w-100">
        <i class="material-icons mb-3" style="font-size: 2.5rem;">error_outline</i>
      </div>
      <div class="mb-3" style="font-size: 1.1rem; line-height: 1.5; word-wrap: break-word; white-space: pre-wrap; max-width: 100%;">
        <strong>${message}</strong>
      </div>
      <button type="button" class="btn-close btn-close-white position-absolute"
              id="closePopup"
              aria-label="Close"
              style="top: 15px; right: 15px; background: none; border: none; font-size: 1.8rem; color: white; cursor: pointer; padding: 8px; opacity: 0.8; transition: opacity 0.2s;">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  `;

  $(popup).appendTo('body');

  // Add responsive styles for mobile
  const style = `
    <style id="popup-responsive-styles">
      #globalPopupMessage:hover .btn-close {
        opacity: 1 !important;
      }

      @media (max-width: 768px) {
        #globalPopupMessage {
          top: 50% !important;
          left: 50% !important;
          transform: translate(-50%, -50%) !important;
          max-width: 95vw !important;
          min-width: 280px !important;
          padding: 25px 20px !important;
        }
      }

      @media (max-width: 480px) {
        #globalPopupMessage {
          min-width: 260px !important;
          padding: 20px 15px !important;
        }
        #globalPopupMessage .mb-3 {
          font-size: 1rem !important;
        }
        #globalPopupMessage .material-icons {
          font-size: 2rem !important;
        }
      }

      /* Add backdrop overlay */
      .popup-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 9998;
        backdrop-filter: blur(2px);
      }
    </style>
  `;

  // Add responsive styles if not already present
  if ($('#popup-responsive-styles').length === 0) {
    $(style).appendTo('head');
  }

  // Enhanced close functionality
  function closePopup() {
    $('#globalPopupMessage').fadeOut(300, function () {
      $(this).remove();
      $('#popup-backdrop').fadeOut(200, function () {
        $(this).remove();
      });
    });
  }

  // Click event for close button
  $('#closePopup').on('click', closePopup);

  // Click outside to close (optional)
  $('#popup-backdrop').on('click', closePopup);

  // Auto-close after specified duration
  setTimeout(function () {
    if ($('#globalPopupMessage').length > 0) {
      closePopup();
    }
  }, duration);

  // Add animation entrance effect
  $('#popup-backdrop').hide().fadeIn(200);
  $('#globalPopupMessage').hide().fadeIn(400);
}

jQuery(document).ready(function () {
  $(document).on('click', '.clickable-td', function () {
    window.location = $(this).closest('tr').data('href');
  });

  $(document).on('click', '.clickable-li', function () {
    window.location = $(this).closest('ul').data('href');
  });

  $(document).on('click', '.clickable-span', function () {
    window.location = $(this).data('href');
  });

  if ($('form.organizer-form').length && p === 'organizer_settings') {
    $(document).on(
      'change',
      'form.organizer-form input, form.organizer-form select, form.organizer-form textarea',
      function () {
        if ($(this).attr('name') == 'location_device[standby_device_id]') {
          $('form.organizer-form').removeClass('has-changed');
          return;
        }

        if (!$('form.organizer-form').hasClass('has-changed')) {
          $('form.organizer-form').addClass('has-changed');
        }

        $(window).bind('beforeunload', function () {
          if (
            $('form.organizer-form').length &&
            $('form.organizer-form').hasClass('has-changed')
          ) {
            return 'Du har ikke lagret skjema - You have unsaved changes';
          }

          return false;
        });
      }
    );
  }

  let p = $('body').attr('p');
  //confirmation dialog while clicking the pagination at products
  // if (p == "events") {
  // $(document).on("click", "a", function (e) {
  //   if (
  //     locationCart &&
  //     locationCart.products &&
  //     locationCart.products.length > 0
  //   ) {
  //     const confirmLeave = confirm(
  //       "⚠️ Du har varer i handlekurven. Vil du gå ut likevel?"
  //     );
  //     if (!confirmLeave) {
  //       e.preventDefault();
  //     }
  //   }
  // });
  // }
  if (
    p == 'organizer_event_customers' ||
    p == 'organizer_location_statistic' ||
    p == 'organizer_booking_reservation'
  ) {
    if ($('body').attr('employer_token') != undefined) {
      let employerToken = $('body').attr('employer_token');
      $('.employer-menu-link').each(function () {
        let linkUrl = $(this).attr('href');
        linkUrl = linkUrl + '?employer_token=' + employerToken;
        $(this).attr('href', linkUrl);
      });
    }
  }

  $(document).on('click', '.expand-btn', function () {
    let icon = 'expand_more';
    if ($(this).hasClass('expand-more')) {
      $(this).removeClass('expand-more').addClass('expand-less');
      icon = 'expand_less';
    } else {
      $(this).removeClass('expand-less').addClass('expand-more');
    }

    if ($('.material-icons', $(this)).length) {
      $('.material-icons', $(this)).text(icon);
    }
  });

  $('[data-toggle="popover"]').popover();

  // Add margin top to content frame based on navbar height
  function adjustContentMargin() {
    let navbarHeight = $('.navbar').height();
    $('#admin-content-frame')
      .find('.flex-grow-1')
      .css('margin-top', navbarHeight + 25 + 'px');
  }

  // Initial adjustment
  adjustContentMargin();

  // Readjust on window resize
  $(window).on('resize', adjustContentMargin);
});

//blinking button
function blinkButton(target, color) {
  // Store the original background color in a CSS variable
  var originalBgColor = $(target).css('background-color');

  // Apply the dynamic color to the button's background
  $(target).css({
    '--blink-color': color, // Set the color for the blinking effect
    '--original-bg-color': originalBgColor, // Store the original background color
  });

  // Add the blinking class to start the animation
  $(target).addClass('blink');

  // Optional: Remove blink and reset background color after 5 seconds
  setTimeout(() => {
    $(target).removeClass('blink').css('background-color', originalBgColor);
  }, 5000);
}

/**
 * Validates an email address
 * @param {string} email - The email address to validate
 * @returns {boolean} True if email is valid, false otherwise
 */
function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (n, x, s, c) {
  let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(
    new RegExp(re, 'g'),
    '$&' + (s || ',')
  );
};

function createDeviceId(length = 8) {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  if (window.crypto && window.crypto.getRandomValues) {
    const array = new Uint32Array(length);
    window.crypto.getRandomValues(array);
    for (let i = 0; i < length; i++) {
      result += chars.charAt(array[i] % chars.length);
    }
  } else {
    // fallback
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
  }
  return result;
}

function createUserDeviceId() {
  if (typeof FingerprintJS === 'undefined') {
    return $.Deferred().reject('FingerprintJS not loaded').promise();
  }

  return FingerprintJS.load()
    .then(function (fp) {
      return fp.get();
    })
    .then(function (result) {
      return result.visitorId;
    });
}

function formattedValueForNumberInput(value) {
  if (typeof value === 'string') {
    value = value.replace(',', '.');
  }

  if (isNaN(value)) {
    return 0;
  }

  return value;
}

function round(value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

function formattedPriceToShow(number) {
  if (!number) {
    return 0;
  }
  let parts = number.toString().split('.');
  let decimals = parts[1]
    ? parts[1].length === 1
      ? parts[1] + '0'
      : parts[1].substring(0, 2)
    : '00';
  let formatted = parts[0] + ',' + decimals;
  return formatted;
}

function formattedPriceToShowForStatistic(number) {
  if (!number) {
    return '0,00';
  }

  // Convert to string and split by decimal point
  let parts = number.toString().split('.');

  // Handle decimal part
  let decimals = parts[1]
    ? parts[1].length === 1
      ? parts[1] + '0'
      : parts[1].substring(0, 2)
    : '00';

  // Handle integer part - add dot separators for thousands
  let integerPart = parts[0];
  let formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Combine with comma as decimal separator
  let formatted = formattedInteger + ',' + decimals;

  return formatted;
}

function floor(value, decimals = 2) {
  return Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

function fmt(n, returnNumber = false) {
  if (returnNumber) {
    return (Math.round(n * 100) / 100).toFixed(2);
  }

  return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
}

function formattedPriceToSetValue(number) {
  if (!number) {
    return 0;
  }
  let parts = number.toString().split('.');
  let decimals = parts[1]
    ? parts[1].length === 1
      ? parts[1] + '0'
      : parts[1].substring(0, 2)
    : '00';
  let formatted = parts[0] + '.' + decimals;
  return parseFloat(formatted);
}

var inactivityTimeoutId = null;

/**
 *
 * @param function callback
 * @param number inactivityTime
 */
function startOrResetFunction(callback, inactivityTime = 300000) {
  clearTimeout(inactivityTimeoutId);

  inactivityTimeoutId = setTimeout(function () {
    callback();
  }, inactivityTime);
}

function clearInactivityTimeout() {
  clearTimeout(inactivityTimeoutId);
}

/**
 * @param {string} input
 * @returns {string}
 */
function dayFormatAbbreviation(input) {
  const days = {
    'sø.': 'Søn',
    'ma.': 'Man',
    'ti.': 'Tir',
    'on.': 'Ons',
    'to.': 'Tor',
    'fr.': 'Fre',
    'lø.': 'Lør',
  };

  if (typeof input !== 'string' || input.length < 2) {
    throw new TypeError('Input must be a string with at least 2 characters');
  }

  const abbreviation = input.slice(0, 3);

  if (days.hasOwnProperty(abbreviation)) {
    return input.replace(abbreviation, days[abbreviation]);
  }

  return input;
}

/**
 * @param {string[]} query
 * @param {boolean} silent
 */
function removeQueryParams(query, silent = true) {
  const urlParams = new URLSearchParams(window.location.search);

  if (Array.isArray(query)) {
    query.forEach((param) => urlParams.delete(param));
  } else {
    urlParams.delete(query);
  }

  const newUrl =
    window.location.pathname +
    (urlParams.toString() ? `?${urlParams.toString()}` : '') +
    window.location.hash;

  const historyMethod = silent
    ? window.history.replaceState
    : window.history.pushState;
  historyMethod.call(window.history, null, '', newUrl);
}

/**
 * Extracts all query parameters from the URL and returns them as an object with URL decoded values
 * @returns {Object} Object containing all query parameters with decoded values
 */
function extractUrlQuery() {
  const params = {};
  const urlParams = new URLSearchParams(window.location.search);

  for (const [key, value] of urlParams) {
    params[decodeURIComponent(key)] = decodeURIComponent(value);
  }

  return params;
}

/**
 *
 * @param {string} period
 * @param {string} dateString
 * @returns
 */
function getPeriodTranslation(period = '', dateString) {
  if (period.includes('month')) {
    return 'måned';
  }

  if (period.includes('week')) {
    return 'uke';
  }

  if (period.includes('day')) {
    // if (!dateString) {
    //   return "No date provided";
    // }

    // const dayMapping = {
    //   monday: "mandag",
    //   tuesday: "tirsdag",
    //   wednesday: "onsdag",
    //   thursday: "torsdag",
    //   friday: "fredag",
    //   saturday: "lørdag",
    //   sunday: "søndag",
    // };

    // const lowerDay = dateString.toLowerCase();

    // if (dayMapping[lowerDay]) {
    //   return dayMapping[lowerDay];
    // }

    // const date = new Date(dateString);
    // if (!isNaN(date.getTime())) {
    //   const norwegianDays = [
    //     "søndag",
    //     "mandag",
    //     "tirsdag",
    //     "onsdag",
    //     "torsdag",
    //     "fredag",
    //     "lørdag",
    //   ];
    //   return norwegianDays[date.getDay()];
    // }

    return '';
  }

  return '';
}

/**
 * Displays a toast notification with customizable options.
 * @param {Object} options - Configuration options for the toast.
 * @param {string} [options.title=""] - The title of the toast.
 * @param {string} [options.message="This is a toast message!"] - The main message of the toast.
 * @param {string} [options.type="info"] - The type of toast: "success", "error", "warning", "info".
 * @param {number} [options.duration=3000] - Duration in milliseconds before auto-hiding.
 * @param {string} [options.position="top-right"] - Position of the toast on the screen.
 * @param {string} [options.icon=""] - Icon to display (defaults based on type if not provided).
 * @param {boolean} [options.autoHide=true] - Whether the toast should automatically hide after duration.
 * @param {boolean} [options.dismissOnSwipe=true] - Whether the toast can be dismissed by swiping right.
 * @param {Object|null} [options.button=null] - Optional button configuration.
 * @param {string} [options.button.text="Action"] - Text for the button.
 * @param {Function} [options.button.onClick] - Callback function when button is clicked, receives toast element and options as arguments.
 * @param {boolean} [options.button.removeOnClick=true] - Whether to remove the toast when the button is clicked.
 * @param {boolean} [options.closeButton=true]
 * @param {boolean} [options.responsive=true] - Whether to make the toast responsive to screen size.
 * @param {number} [options.buttonDelay=0] - Delay in milliseconds before showing the button (default 0, meaning immediate).
 * @param {number} [options.afterDelay=0] - Delay before running afterDelayCallback.
 * @param {Function|null} [options.afterDelayCallback=null] - Function to run after delay.
 * @param {Function|null} [options.onClose=null] - Callback function when toast is closed.
 * @param {string} [options.size="md"] - The size of the toast: "sm", "md", "lg", "xl".
 * @returns {void}
 */
function showToast(options) {
  var defaults = {
    title: '',
    message: 'This is a toast message!',
    type: 'info',
    size: 'md', // sm, md, lg, xl
    duration: 3000,
    position: 'top-right',
    icon: '',
    autoHide: true,
    dismissOnSwipe: true,
    button: null,
    closeButton: false,
    responsive: true,
    buttonDelay: 0,
    afterDelay: 0,
    afterDelayCallback: null,
    onClose: null,
  };

  var settings = $.extend(true, {}, defaults, options);

  // Define size configurations
  var sizeMap = {
    sm: {
      width: '300px',
      padding: '10px 15px',
      icon: '20px',
      title: '14px',
      message: '12px',
      gap: '10px',
    },
    md: {
      width: '400px',
      padding: '15px 20px',
      icon: '24px',
      title: '16px',
      message: '14px',
      gap: '15px',
    },
    lg: {
      width: '500px',
      padding: '20px 25px',
      icon: '30px',
      title: '20px',
      message: '16px',
      gap: '20px',
    },
    xl: {
      width: '600px',
      padding: '25px 35px',
      icon: '40px',
      title: '24px',
      message: '18px',
      gap: '25px',
    },
  };

  var currentSize = sizeMap[settings.size] || sizeMap.md;

  if (!settings.icon) {
    switch (settings.type) {
      case 'success':
        settings.icon = 'check_circle';
        break;
      case 'error':
        settings.icon = 'error';
        break;
      case 'warning':
        settings.icon = 'warning';
        break;
      case 'info':
        settings.icon = 'info';
        break;
      default:
        settings.icon = 'notifications';
    }
  }

  var isSmallScreen = settings.responsive && $(window).width() < 768;
  var effectivePosition = settings.position;
  if (
    settings.responsive &&
    !settings.position.includes('bottom') &&
    isSmallScreen
  ) {
    effectivePosition = 'bottom-center';
  }

  var $toast = $("<div style='z-index:9999'></div>").addClass(
    'toaster ' + settings.type + ' ' + effectivePosition
  );

  $toast.css({
    display: 'flex',
    flexDirection: 'column',
    width: isSmallScreen ? '90%' : currentSize.width,
    margin: isSmallScreen ? '0 auto' : '0',
    padding: currentSize.padding,
    borderRadius: '8px',
    boxSizing: 'border-box',
  });

  var $toastContentContainer = $(
    '<div class="toast-content-container"></div>'
  ).css({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    textAlign: 'left',
    width: '100%',
  });

  var $icon = $('<i class="material-icons"></i>').text(settings.icon).css({
    fontSize: currentSize.icon,
    marginRight: currentSize.gap,
  });
  $toastContentContainer.append($icon);

  var $content = $('<div class="toast-content"></div>').css({
    flex: '1',
    marginRight: settings.closeButton ? '20px' : '0',
  });

  if (settings.title) {
    var $title = $('<h4 class="toast-title"></h4>').text(settings.title).css({
      margin: '0 0 5px 0',
      fontSize: currentSize.title,
      fontWeight: 'bold',
    });
    $content.append($title);
  }

  var $message = $('<p class="toast-message"></p>').text(settings.message).css({
    margin: '0',
    fontSize: currentSize.message,
    lineHeight: '1.5',
  });

  $content.append($message);
  $toastContentContainer.append($content);
  $toast.append($toastContentContainer);

  // Function to add the button
  function addButton() {
    if (settings.button) {
      var $buttonContainer = $(
        '<div class="toast-button-container"></div>'
      ).css({
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginTop: '10px',
      });

      var $button = $('<button class="toast-button"></button>')
        .text(settings.button.text || 'Action')
        .css({
          padding: settings.size === 'sm' ? '4px 10px' : '8px 16px',
          fontSize: currentSize.message,
          borderRadius: '4px',
          border: 'none',
          backgroundColor: 'rgba(255,255,255,0.2)',
          color: 'inherit',
          cursor: 'pointer',
        });

      if (settings.button.onClick) {
        $button.on('click', function () {
          settings.button.onClick($toast, settings);
          if (settings.button.removeOnClick !== false) {
            hideToast();
          }
        });
      }
      $buttonContainer.append($button);
      $toast.append($buttonContainer);
    }
  }

  if (settings.closeButton) {
    var $closeBtn = $('<i class="material-icons toast-close-btn p-0"></i>')
      .text('close')
      .css({
        position: 'absolute',
        top: '10px',
        right: '10px',
        fontSize: settings.size === 'sm' ? '18px' : '22px',
        cursor: 'pointer',
        opacity: '0.6',
        transition: 'opacity 0.2s',
      })
      .hover(
        function () {
          $(this).css('opacity', '1');
        },
        function () {
          $(this).css('opacity', '0.6');
        }
      );

    $closeBtn.on('click', function () {
      hideToast();
      if (typeof settings.onClose === 'function') {
        settings.onClose($toast, settings);
      }
    });

    $toast.append($closeBtn);
  }

  if (settings.buttonDelay > 0) {
    setTimeout(addButton, settings.buttonDelay);
  } else if (settings.button) {
    addButton();
  }

  if (
    settings.afterDelay > 0 &&
    typeof settings.afterDelayCallback === 'function'
  ) {
    $toast.afterDelayTimer = setTimeout(() => {
      settings.afterDelayCallback($toast, settings);
    }, settings.afterDelay);
  }

  $('body').append($toast);

  setTimeout(function () {
    $toast.addClass('show');
  }, 10);

  var hideToast = function () {
    $toast.removeClass('show');
    setTimeout(function () {
      $toast.remove();
    }, 300);
  };

  if (settings.autoHide) {
    setTimeout(hideToast, settings.duration);
  }

  // Swipe logic...
  if (settings.dismissOnSwipe) {
    var startX = 0;
    var currentX = 0;
    $toast
      .on('touchstart', function (e) {
        startX = e.touches[0].clientX;
        $toast.css('transition', 'none');
      })
      .on('touchmove', function (e) {
        currentX = e.touches[0].clientX - startX;
        if (currentX > 0) {
          $toast.css({
            transform: `translateX(${currentX}px)`,
            opacity: 1 - currentX / 200,
          });
        }
      })
      .on('touchend', function () {
        $toast.css('transition', 'transform 0.3s ease, opacity 0.3s ease');
        if (currentX > 75) {
          $toast.css({ transform: 'translateX(100%)', opacity: 0 });
          setTimeout(function () {
            $toast.remove();
          }, 300);
        } else {
          $toast.css({ transform: 'translateX(0)', opacity: 1 });
        }
      });
  }

  $toast.close = hideToast;
  return $toast;
}

function showToastForDashboard(options) {
  var defaults = {
    title: '',
    message: 'This is a toast message!',
    type: 'info',
    duration: 3000, // if 0 → persistent
    position: 'top-right',
    icon: '',
  };

  var settings = $.extend({}, defaults, options);

  if (!settings.icon) {
    switch (settings.type) {
      case 'success':
        settings.icon = 'check_circle';
        break;
      case 'error':
        settings.icon = 'error';
        break;
      case 'warning':
        settings.icon = 'warning';
        break;
      case 'info':
        settings.icon = 'info';
        break;
      default:
        settings.icon = 'notifications';
    }
  }

  var $toast = $("<div style='z-index:9999'></div>").addClass(
    'toaster ' + settings.type + ' ' + settings.position
  );

  $toast.append($('<i class="material-icons"></i>').text(settings.icon));

  var $content = $('<div class="toast-content"></div>');
  if (settings.title) {
    $content.append($('<h4 class="toast-title"></h4>').text(settings.title));
  }
  $content.append($('<p class="toast-message"></p>').text(settings.message));
  $toast.append($content);

  $('body').append($toast);

  setTimeout(() => $toast.addClass('show'), 10);

  // 👇 only auto-remove if duration > 0
  if (settings.duration > 0) {
    setTimeout(() => {
      $toast.removeClass('show');
      setTimeout(() => $toast.remove(), 300);
    }, settings.duration);
  }

  return $toast; // <--- critical: return element so caller can update it
}

function enableSwipe(containerId, options = {}) {
  const $container = $(`#${containerId}`);
  let touchStartX = 0;
  const threshold = options.threshold || 50;
  const preventDefault = options.preventDefault || false;

  $container.on('touchstart mousedown', (e) => {
    if (preventDefault) e.preventDefault();
    if (e.originalEvent.touches) {
      touchStartX = e.originalEvent.touches[0].clientX;
    } else {
      touchStartX = e.originalEvent.clientX;
    }
  });

  $container.on('touchmove mousemove', (e) => {
    if (!touchStartX) return;
    if (preventDefault) e.preventDefault();

    const currentX = e.originalEvent.touches
      ? e.originalEvent.touches[0].clientX
      : e.originalEvent.clientX;
    const deltaX = currentX - touchStartX;

    if (deltaX > threshold) {
      $container.trigger('swiperight');
      touchStartX = 0;
    } else if (deltaX < -threshold) {
      $container.trigger('swipeleft');
      touchStartX = 0;
    }
  });

  $container.on('touchend', () => {
    touchStartX = 0;
  });
}

function decodeHtml(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

function clearLocalStorageOnLogout() {
  $(document).on('click', 'a[href="/logout"]', function () {
    localStorage.removeItem('lastOrderTotal');
    localStorage.removeItem('lastOrderProducts');
  });

  if (window.location.pathname === '/logout') {
    localStorage.removeItem('lastOrderTotal');
    localStorage.removeItem('lastOrderProducts');
  }
}

function unshorten(shortened, callback) {
  // 1. Base64 decode → binary
  const binary = atob(shortened);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));

  // 2. Gunzip using DecompressionStream
  const stream = new DecompressionStream('gzip');
  const writer = stream.writable.getWriter();
  writer.write(bytes);
  writer.close();

  // 3. Read decompressed bytes → string
  const reader = stream.readable.getReader();
  const chunks = [];

  function read() {
    reader.read().then(function (result) {
      if (result.done) {
        const decompressed = new TextDecoder().decode(
          new Uint8Array(
            chunks.flatMap(function (c) {
              return Array.from(c);
            })
          )
        );
        callback(JSON.parse(decompressed));
      } else {
        chunks.push(result.value);
        read();
      }
    });
  }

  read();
}

function sendWhenReady(socket, data) {
  return new Promise((resolve, reject) => {
    if (socket.readyState === WebSocket.OPEN) {
      socket.send(data);
      resolve();
    } else if (socket.readyState === WebSocket.CONNECTING) {
      socket.addEventListener('open', function handler() {
        socket.removeEventListener('open', handler);
        socket.send(data);
        resolve();
      });
      socket.addEventListener('error', function errHandler(err) {
        socket.removeEventListener('error', errHandler);
        reject(err);
      });
    } else {
      reject(new Error('WebSocket is closed or closing'));
    }
  });
}

clearLocalStorageOnLogout();
